module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.reviews.length > 0) ? _c('table', {
    staticClass: "table-confirmation"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('table', {
    staticClass: "table-confirmation"
  }, [_c('tbody', [_vm._l((_vm.reviews), function(item) {
    return _c('tr', {
      class: {
        'danger-row': !item.evaluation_action && (item.last_action.status.key === 'rejeitado' || item.last_action.status.key === 'cancelado')
      }
    }, [_c('td', [_vm._v("\n                        " + _vm._s(item.registration.person.pessoa.nome) + "\n                        "), (item.last_action.notes) ? _c('div', {
      staticStyle: {
        "padding-top": "5px"
      }
    }, [_c('strong', [_vm._v("Observações do Avaliador:")]), _vm._v(" " + _vm._s(item.last_action.notes) + "\n                        ")]) : _vm._e()]), _vm._v(" "), (item.evaluation_action) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.averageResponsesEvaluation(item)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (item.evaluation_action) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm._f("dateTimeEnToBr")(item.last_action.created_at)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!item.evaluation_action) ? _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(item.last_action.status.key === 'rejeitado') ? _c('span', [_vm._v("Rejeitado pelo avaliador")]) : _vm._e(), _vm._v(" "), (item.last_action.status.key === 'cancelado') ? _c('span', [_vm._v("Avaliação cancelada")]) : _vm._e(), _vm._v(" "), (item.last_action.status.key === 'atribuido' || item.last_action.status.key === 'aceito') ? _c('span', [_vm._v("\n                            Aguardando avaliação\n                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "width": "50"
      }
    }, [(item.last_action.status.key === 'avaliado' && !_vm.evaluationType.evaluation_finished && (_vm.paperStatusKey !== 'finalizado' && _vm.paperStatusKey !== 'aguardando_publicacao')) ? _c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small",
        "title": "Remover notas da avaliação"
      },
      on: {
        "click": function($event) {
          _vm.resetEvaluation(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]) : _vm._e(), _vm._v(" "), ((item.last_action.status.key === 'atribuido' || item.last_action.status.key === 'aceito') && !_vm.evaluationType.evaluation_finished) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "title": "Cancelar essa avaliação"
      },
      on: {
        "click": function($event) {
          _vm.cancelEvaluation(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1)])
  }), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.averageEvaluations))]), _vm._v(" "), _c('td')])], 2)])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Avaliações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Média")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78e69853!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/show/paper/evaluation/Responses.vue
// module id = 771
// module chunks = 2